import { render } from "./FormDatePicker.vue?vue&type=template&id=9bf07da0"
import script from "./FormDatePicker.vue?vue&type=script&lang=js"
export * from "./FormDatePicker.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__